import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import EULApdf from '../../../assests/privacy-policy/aurora-EULA-2025-v2.pdf';
import { footerLinksURLs } from '../../../constants/constants';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
} from '../../../constants/analyticsConstants';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { memo, useRef } from 'react';

const AurFooter = () => {
  const currentYear = useRef(new Date().getFullYear().toString()).current;
  const { trackGAEvent } = useAnalytics();
  const trackGA = (name: string) => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t(name),
        region: GA_REGIONS.FOOTER,
        type: GA_CLICK_TYPES.LINK,
        action: t('gaTracking.global.footerLinkClick', { name: t(name) }),
      },
    });
  };

  return (
    <Box className="aur-footer">
      <Box className="footer-section-copyright">
        <Box className="text">
          <Typography className=" typo-text body3_size">
            {t('common.footer.copyRightText', { currentYear })}
          </Typography>
        </Box>
        <Box className="links">
          <Link
            data-testid="privacy-policy-link"
            to={footerLinksURLs.PRIVACY_POLICY_GDPR}
            onClick={() => {
              trackGA('common.footer.privacyPolicyGdpr');
            }}
            target="_blank"
            className="typo-text buttonSmall_size"
          >
            {t('common.footer.privacyPolicyGdpr')}
          </Link>
          <a
            href={EULApdf}
            className="typo-text buttonSmall_size"
            download={t('common.footer.eulaFileName')}
            onClick={() => {
              trackGA('common.footer.eula');
            }}
          >
            {t('common.footer.eula')}
          </a>
          <Link
            to={footerLinksURLs.COOKIE_POLICY}
            className="typo-text buttonSmall_size"
            target="_blank"
            onClick={() => {
              trackGA('common.footer.cookiePolicy');
            }}
          >
            {t('common.footer.cookiePolicy')}
          </Link>
          <Link
            to={footerLinksURLs.MODERN_ANTI_SLAVERY_POLICY}
            className="typo-text buttonSmall_size"
            target="_blank"
            onClick={() => {
              trackGA('common.footer.modernASPolicy');
            }}
          >
            {t('common.footer.modernASPolicy')}
          </Link>
        </Box>
      </Box>

      <Box className="footer-section-text">
        <Typography className="typo-text body4_size">
          {t('common.footer.text2').split('{privacyPolicyGdpr2}')[0]}
          <Link
            to={footerLinksURLs.PRIVACY_POLICY_GDPR}
            target="_blank"
            onClick={() => trackGA('common.footer.privacyPolicyGdpr2')}
          >
            {t('common.footer.privacyPolicyGdpr2')}
          </Link>
          {
            t('common.footer.text2')
              .split('{privacyPolicyGdpr2}')[1]
              .split('{eula2}')[0]
          }
          <a
            href={EULApdf}
            download={t('common.footer.eulaFileName').replace(/ /g, '\u00A0')}
            onClick={() => trackGA('common.footer.eula2')}
          >
            {t('common.footer.eula2')}
          </a>
          {t('common.footer.text2').split('{eula2}')[1]}
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(AurFooter);
